import { useQuery } from '@apollo/client';
import { Store } from '@website/Store';
import { FetchUsersWaitListDocument } from '@website/types/graphqlOperations';
import { useContext } from 'react';

export default function useFetchUsersWaitList() {
  const { state } = useContext(Store);
  const userID = state.user?.id;

  const { data } = useQuery(FetchUsersWaitListDocument, {
    variables: {
      userID,
    },
    skip: !userID,
  });

  // return list of users waitList Group
  return data?.user.waitList.items;
}
